import React from 'react';
import { useWarehouseManagementData } from '../warehouse/management/useWarehouseManagementData';
import WarehousesTab from '../warehouse/management/WarehousesTab';
import EmployeesTab from '../warehouse/management/EmployeesTab';
import WarehouseModal from '../warehouse/management/WarehouseModal';
import EmployeeModal from '../warehouse/management/EmployeeModal';

const AlertBanner = ({ message, type, onDismiss }) => {
  const colors = type === 'error'
    ? { bg: 'var(--danger-light)', border: 'var(--danger-light)', text: 'var(--danger)' }
    : { bg: 'var(--success-light)', border: 'var(--success-light)', text: 'var(--success)' };
  return (
    <div style={{
      marginBottom: '1rem', padding: '0.75rem 1rem',
      backgroundColor: colors.bg, border: `1px solid ${colors.border}`,
      borderRadius: '0.375rem', color: colors.text,
      display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    }}>
      {message}
      <button style={{ background: 'none',  color: colors.text, fontSize: '18px', cursor: 'pointer' }} onClick={onDismiss}>
        X
      </button>
    </div>
  );
};

const tabBtnStyle = (active) => ({
  padding: '6px 12px',
  background: active ? 'var(--info)' : 'transparent',
  color: active ? '#fff' : 'var(--info)',
  borderBottom: active ? '3px solid var(--info)' : '3px solid transparent',
  cursor: 'pointer', fontSize: '12px', fontWeight: active ? '600' : '500', transition: 'all 0.3s ease'
});

const WarehouseManagement = () => {
  const {
    warehouses, employees, users, locations,
    loading, error, success, setError, setSuccess,
    activeTab, setActiveTab,
    showWarehouseModal, showEmployeeModal,
    editingWarehouse,
    warehouseForm, setWarehouseForm,
    employeeForm, setEmployeeForm,
    handleWarehouseSubmit, handleEmployeeSubmit,
    handleDeleteWarehouse, handleRemoveEmployee,
    editWarehouse,
    openNewWarehouseModal, openNewEmployeeModal,
    closeWarehouseModal, closeEmployeeModal
  } = useWarehouseManagementData();

  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      {error && <AlertBanner message={error} type="error" onDismiss={() => setError(null)} />}
      {success && <AlertBanner message={success} type="success" onDismiss={() => setSuccess(null)} />}

      {/* Tabs */}
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '2px solid var(--border)', marginBottom: '1rem' }}>
          {[{ key: 'warehouses', label: 'Magazyny' }, { key: 'employees', label: 'Przypisania pracownikow' }].map(tab => (
            <button
              key={tab.key}
              style={tabBtnStyle(activeTab === tab.key)}
              onClick={() => setActiveTab(tab.key)}
              onMouseOver={(e) => { if (activeTab !== tab.key) e.target.style.backgroundColor = 'var(--bg)'; }}
              onMouseOut={(e) => { if (activeTab !== tab.key) e.target.style.backgroundColor = 'transparent'; }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === 'warehouses' && (
        <WarehousesTab
          warehouses={warehouses}
          locations={locations}
          loading={loading}
          onAdd={openNewWarehouseModal}
          onEdit={editWarehouse}
          onDelete={handleDeleteWarehouse}
        />
      )}

      {activeTab === 'employees' && (
        <EmployeesTab
          employees={employees}
          onAdd={openNewEmployeeModal}
          onRemove={handleRemoveEmployee}
        />
      )}

      <WarehouseModal
        isOpen={showWarehouseModal}
        editingWarehouse={editingWarehouse}
        warehouseForm={warehouseForm}
        setWarehouseForm={setWarehouseForm}
        locations={locations}
        users={users}
        onSubmit={handleWarehouseSubmit}
        onClose={closeWarehouseModal}
        loading={loading}
      />

      <EmployeeModal
        isOpen={showEmployeeModal}
        warehouses={warehouses}
        users={users}
        employeeForm={employeeForm}
        setEmployeeForm={setEmployeeForm}
        onSubmit={handleEmployeeSubmit}
        onClose={closeEmployeeModal}
        loading={loading}
      />
    </div>
  );
};

export default WarehouseManagement;
